import { injected, metaMask, walletConnect } from '@wagmi/connectors';
import { Chain, defineChain } from 'viem';
import { cookieStorage, createConfig, createStorage, http } from 'wagmi';
import {
	acala,
	ancient8,
	ancient8Sepolia,
	anvil,
	apexTestnet,
	arbitrum,
	arbitrumGoerli,
	arbitrumNova,
	arbitrumSepolia,
	areonNetwork,
	areonNetworkTestnet,
	astar,
	astarZkEVM,
	astarZkyoto,
	aurora,
	auroraTestnet,
	auroria,
	avalanche,
	avalancheFuji,
	bahamut,
	base,
	baseGoerli,
	baseSepolia,
	beam,
	beamTestnet,
	bearNetworkChainMainnet,
	bearNetworkChainTestnet,
	berachainTestnet,
	bevmMainnet,
	bitkub,
	bitkubTestnet,
	bitTorrent,
	bitTorrentTestnet, // blast,
	blastSepolia,
	bob,
	boba,
	bobaSepolia,
	bronos,
	bronosTestnet,
	bsc,
	bscGreenfield,
	bscTestnet,
	btr,
	btrTestnet,
	bxn,
	bxnTestnet,
	canto,
	celo,
	celoAlfajores,
	chiliz,
	citreaTestnet,
	classic,
	confluxESpace,
	confluxESpaceTestnet,
	coreDao,
	cronos,
	cronosTestnet,
	crossbell,
	cyber,
	cyberTestnet,
	darwinia,
	defichainEvm,
	defichainEvmTestnet,
	degen,
	dfk,
	dodochainTestnet,
	dogechain,
	dreyerxMainnet,
	edgeless,
	edgelessTestnet,
	edgeware,
	edgewareTestnet,
	ekta,
	ektaTestnet,
	eon,
	eos,
	eosTestnet,
	etherlinkTestnet,
	evmos, // evmosTestnet,
	fantom,
	fantomSonicTestnet,
	fantomTestnet,
	fibo,
	filecoin,
	filecoinCalibration,
	filecoinHyperspace,
	flare,
	flareTestnet,
	flowMainnet,
	flowPreviewnet,
	flowTestnet,
	foundry,
	fraxtal,
	fraxtalTestnet,
	funkiSepolia,
	fuse,
	fuseSparknet,
	gnosis,
	gnosisChiado,
	gobi,
	goerli,
	ham,
	haqqMainnet,
	haqqTestedge2,
	hardhat,
	harmonyOne,
	hedera,
	hederaPreviewnet,
	hederaTestnet,
	holesky,
	immutableZkEvm,
	immutableZkEvmTestnet,
	inEVM,
	iotex,
	iotexTestnet,
	jbc,
	jbcTestnet,
	kakarotSepolia,
	karura,
	kava,
	kavaTestnet,
	kcc, // klaytn, // klaytnBaobab,
	kroma,
	kromaSepolia,
	l3x,
	l3xTestnet,
	lightlinkPegasus,
	lightlinkPhoenix,
	linea,
	lineaGoerli,
	lineaSepolia,
	lineaTestnet,
	lisk,
	liskSepolia,
	localhost,
	lukso,
	luksoTestnet,
	lycan,
	mainnet,
	mandala,
	manta,
	mantaSepoliaTestnet,
	mantaTestnet, // mantle,
	mantleSepoliaTestnet,
	mantleTestnet,
	merlin,
	metachain,
	metachainIstanbul,
	metalL2,
	meter,
	meterTestnet,
	metis,
	metisGoerli,
	mev,
	mevTestnet, // mintSepoliaTestnet,
	mode,
	modeTestnet,
	moonbaseAlpha,
	moonbeam,
	moonbeamDev,
	moonriver,
	morphSepolia,
	nautilus,
	neonDevnet,
	neonMainnet,
	nexi,
	nexilix,
	oasisTestnet,
	oasys,
	okc,
	oortMainnetDev,
	opBNB,
	opBNBTestnet,
	optimism,
	optimismGoerli,
	optimismSepolia,
	otimDevnet,
	palm,
	palmTestnet,
	pgn,
	pgnTestnet,
	phoenix,
	playfiAlbireo,
	plinga, // plumeTestnet,
	plumeMainnet,
	polygon,
	polygonAmoy,
	polygonMumbai,
	polygonZkEvm,
	polygonZkEvmCardona,
	polygonZkEvmTestnet,
	pulsechain,
	pulsechainV4,
	qMainnet,
	qTestnet,
	redbellyTestnet,
	redstone,
	reyaNetwork,
	rollux,
	rolluxTestnet,
	ronin,
	rootstock,
	rootstockTestnet,
	rss3,
	rss3Sepolia,
	saigon,
	sapphire,
	sapphireTestnet,
	satoshiVM,
	satoshiVMTestnet,
	scroll,
	scrollSepolia,
	sei,
	seiDevnet,
	sepolia,
	shardeumSphinx,
	shibarium,
	shimmer,
	shimmerTestnet,
	skaleBlockBrawlers,
	skaleCalypso,
	skaleCalypsoTestnet,
	skaleCryptoBlades,
	skaleCryptoColosseum,
	skaleEuropa,
	skaleEuropaTestnet,
	skaleExorde,
	skaleHumanProtocol,
	skaleNebula,
	skaleNebulaTestnet,
	skaleRazor,
	skaleTitan,
	skaleTitanTestnet,
	songbird,
	songbirdTestnet,
	spicy,
	stratis,
	syscoin, // syscoinTestnet,
	taiko,
	taikoHekla,
	taikoJolnir,
	taikoKatla,
	taikoTestnetSepolia,
	taraxa,
	taraxaTestnet,
	telcoinTestnet,
	telos,
	telosTestnet,
	tenet,
	thaiChain,
	thunderTestnet,
	vechain,
	wanchain,
	wanchainTestnet,
	wemix,
	wemixTestnet,
	xai,
	xaiTestnet,
	xdc,
	xdcTestnet,
	xLayer,
	xLayerTestnet,
	yooldoVerse,
	yooldoVerseTestnet,
	zetachain,
	zetachainAthensTestnet,
	zhejiang,
	zilliqa,
	zilliqaTestnet,
	zkFair,
	zkFairTestnet,
	zksync,
	zora,
	zoraSepolia,
	zoraTestnet,
} from 'wagmi/chains';

import getBaseUrl from '@/utils/helpers/getBaseUrl';

import { apiAssetsUrl, walletConnectProjectId } from './config';

//Additional mainnet chains
const goldFever = defineChain({
	id: 1853,
	name: 'Gold Fever Mainnet',
	nativeCurrency: { name: 'NGL', symbol: 'NGL', decimals: 18 },
	rpcUrls: {
		default: {
			http: ['https://subnets.avax.network/highoctane/mainnet/rpc'],
		},
	},
	blockExplorers: {
		default: { name: 'Avalanche Subnet Explorer', url: 'https://subnets.avax.network/highoctane' },
	},
	contracts: {},
});

export const klaytn = /*#__PURE__*/ defineChain({
	id: 8_217,
	name: 'Klaytn',
	nativeCurrency: {
		decimals: 18,
		name: 'Klaytn',
		symbol: 'KLAY',
	},
	rpcUrls: {
		default: { http: ['https://1rpc.io/klay'] },
	},
	blockExplorers: {
		default: {
			name: 'KlaytnScope',
			url: 'https://scope.klaytn.com',
		},
	},
	contracts: {
		multicall3: {
			address: '0xcA11bde05977b3631167028862bE2a173976CA11',
			blockCreated: 96002415,
		},
	},
});

export const mantle = /*#__PURE__*/ defineChain({
	id: 5000,
	name: 'Mantle',
	nativeCurrency: {
		decimals: 18,
		name: 'MNT',
		symbol: 'MNT',
	},
	rpcUrls: {
		default: { http: ['https://rpc.ankr.com/mantle'] },
	},
	blockExplorers: {
		default: {
			name: 'Mantle Explorer',
			url: 'https://mantlescan.xyz/',
			apiUrl: 'https://api.mantlescan.xyz/api',
		},
	},
	contracts: {
		multicall3: {
			address: '0xcA11bde05977b3631167028862bE2a173976CA11',
			blockCreated: 304717,
		},
	},
});

export const blast = /*#__PURE__*/ defineChain({
	id: 81457,
	name: 'Blast',
	nativeCurrency: {
		decimals: 18,
		name: 'Ether',
		symbol: 'ETH',
	},
	rpcUrls: {
		default: { http: ['https://blast.din.dev/rpc'] },
	},
	blockExplorers: {
		default: {
			name: 'Blastscan',
			url: 'https://blastscan.io',
			apiUrl: 'https://api.blastscan.io/api',
		},
	},
	contracts: {
		multicall3: {
			address: '0xcA11bde05977b3631167028862bE2a173976CA11',
			blockCreated: 212929,
		},
	},
});

//Additional testnet chains
const dfkTestnet = defineChain({
	id: 335,
	name: 'DFK Testnet',
	nativeCurrency: { name: 'Jewel', symbol: 'JEWEL', decimals: 18 },
	rpcUrls: {
		default: {
			http: ['https://subnets.avax.network/defi-kingdoms/dfk-chain-testnet/rpc'],
		},
	},
	blockExplorers: {
		default: { name: 'Avascan', url: 'https://testnet.avascan.info/blockchain/dfk/home' },
	},
	contracts: {},
});

const dogechainDevnet = defineChain({
	id: 568,
	name: 'Dogechain Testnet',
	nativeCurrency: { name: 'DOGE', symbol: 'DOGE', decimals: 18 },
	rpcUrls: {
		default: {
			http: ['https://rpc-testnet.dogechain.dog'],
		},
	},
	blockExplorers: {
		default: { name: 'Dogechain Explorer', url: 'https://explorer-testnet.dogechain.dog/' },
	},
	contracts: {},
});

const bobaTestnet = defineChain({
	id: 9728,
	name: 'Boba BNB Testnet',
	nativeCurrency: { name: 'BOBA', symbol: 'BOBA', decimals: 18 },
	rpcUrls: {
		default: {
			http: ['https://testnet.bnb.boba.network'],
		},
	},
	blockExplorers: {
		default: { name: 'Boba BNB Explorer', url: 'https://bnb.testnet.bobascan.com/' },
	},
	contracts: {},
});

const harmonyTestnet = defineChain({
	id: 1666700000,
	name: 'Harmony Testnet',
	nativeCurrency: { name: 'Harmony', symbol: 'ONE', decimals: 18 },
	rpcUrls: {
		default: {
			http: ['https://endpoints.omniatech.io/v1/harmony/testnet-0/public'],
		},
	},
	blockExplorers: {
		default: { name: 'Harmony Testnet Explorer', url: 'https://explorer.testnet.harmony.one' },
	},
	contracts: {},
});

const okexTestnet = defineChain({
	id: 65,
	name: 'OKEx Testnet',
	nativeCurrency: { name: 'OKX', symbol: 'OKX', decimals: 18 },
	rpcUrls: {
		default: {
			http: ['https://exchaintestrpc.okex.org'],
		},
	},
	blockExplorers: {
		default: { name: 'OKTC Test Explorer', url: 'https://www.okx.com/web3/explorer/oktc-test' },
	},
	contracts: {},
});

const kccTestnet = defineChain({
	id: 322,
	name: 'KuCoin Community Chain Testnet',
	nativeCurrency: { name: 'KCC', symbol: 'tKCS', decimals: 18 },
	rpcUrls: {
		default: {
			http: ['https://rpc-testnet.kcc.network'],
		},
	},
	blockExplorers: {
		default: { name: 'Testnet KCC Explorer', url: 'https://scan-testnet.kcc.network/' },
	},
	contracts: {},
});

const roninTestnet = defineChain({
	id: 2021,
	name: 'Saigon Testnet',
	nativeCurrency: { name: 'RON', symbol: 'RON', decimals: 18 },
	rpcUrls: {
		default: {
			http: ['https://saigon-testnet.roninchain.com/rpc'],
		},
	},
	blockExplorers: {
		default: { name: 'Ronin Saigon Testnet Block Explorer', url: 'https://saigon-app.roninchain.com/' },
	},
	contracts: {},
});

const goldFeverTestnet = defineChain({
	id: 20948,
	name: 'Gold Fever Testnet',
	nativeCurrency: { name: 'NGL', symbol: 'NGL', decimals: 18 },
	rpcUrls: {
		default: {
			http: ['https://subnets.avax.network/goldfever/testnet/rpc'],
		},
	},
	blockExplorers: {
		default: { name: 'Avalanche Subnet Explorer', url: 'https://subnets.avax.network/highoctane' },
	},
	contracts: {},
});

const apechainTestnet = defineChain({
	id: 33111,
	name: 'ApeChain Testnet',
	nativeCurrency: { name: 'APE', symbol: 'APE', decimals: 18 },
	rpcUrls: {
		default: {
			http: ['https://curtis.rpc.caldera.xyz/http'],
		},
	},
	blockExplorers: {
		default: { name: 'Apechain Testnet Explorer', url: 'https://jenkins.explorer.caldera.xyz/' },
	},
});

const metisSepolia = defineChain({
	id: 59902,
	name: 'Metis Sepolia',
	nativeCurrency: { name: 'METIS', symbol: 'METIS', decimals: 18 },
	rpcUrls: {
		default: {
			http: ['https://sepolia.metisdevops.link'],
		},
	},
	blockExplorers: {
		default: { name: 'Metis Sepolia Testnet Explorer', url: 'https://sepolia-explorer.metisdevops.link/' },
	},
	contracts: {},
});

const viction = defineChain({
	id: 89,
	name: 'Viction',
	nativeCurrency: { name: 'Viction', symbol: 'VIC', decimals: 18 },
	rpcUrls: {
		default: {
			http: ['https://rpc-testnet.viction.xyz'],
		},
	},
	blockExplorers: {
		default: { name: 'Viction Blockchain Explorer', url: 'https://testnet.vicscan.xyz/' },
	},
	contracts: {},
});

const coreDaoTestnet = defineChain({
	id: 1115,
	name: 'Core Dao Testnet',
	nativeCurrency: { name: 'Core', symbol: 'CORE', decimals: 18 },
	rpcUrls: {
		default: {
			http: ['https://rpc.test.btcs.network'],
		},
	},
	blockExplorers: {
		default: { name: 'Core Testnet Scan', url: 'https://scan.test.btcs.network/' },
	},
	contracts: {},
});

const game7Testnet = defineChain({
	id: 13746,
	name: 'Game7 Testnet',
	nativeCurrency: { name: 'Game7', symbol: 'G7', decimals: 18 },
	rpcUrls: {
		default: {
			http: ['https://testnet-rpc.game7.io'],
		},
	},
	blockExplorers: {
		default: { name: 'Game7 Testnet explorer', url: 'https://testnet.game7.io/' },
	},
	contracts: {},
});

export const klaytnBaobab = /*#__PURE__*/ defineChain({
	id: 1001,
	name: 'Kaia Kairos Testnet',
	nativeCurrency: {
		decimals: 18,
		name: 'Klay',
		symbol: 'KLAY',
	},
	rpcUrls: {
		default: { http: ['https://public-en-kairos.node.kaia.io'] },
	},
	blockExplorers: {
		default: {
			name: 'KlaytnScope',
			url: 'https://kairos.kaiascope.com/',
		},
	},
});

export const sonicBlazeTestnet = /*#__PURE__*/ defineChain({
	id: 57054,
	name: 'Sonic Blaze Testnet',
	nativeCurrency: {
		decimals: 18,
		name: 'Sonic Blaze',
		symbol: 'S',
	},
	rpcUrls: {
		default: { http: ['https://rpc.blaze.soniclabs.com'] },
	},
	blockExplorers: {
		default: {
			name: 'Sonic Blaze Testnet Explorer',
			url: 'https://testnet.sonicscan.org/',
		},
	},
});

export const japanOpenChainTestnet = /*#__PURE__*/ defineChain({
	id: 10081,
	name: 'Japan Open Chain Testnet',
	nativeCurrency: {
		decimals: 18,
		name: 'Japan Open Chain Token',
		symbol: 'JOC',
	},
	rpcUrls: {
		default: { http: ['https://rpc-1.testnet.japanopenchain.org:8545'] },
	},
	blockExplorers: {
		default: {
			name: 'Japan Open Chain blockchain explorer',
			url: 'https://explorer.japanopenchain.org/',
		},
	},
});

export const nibiruTestnet = /*#__PURE__*/ defineChain({
	id: 6911,
	name: 'Nibiru Testnet',
	nativeCurrency: {
		decimals: 18,
		name: 'Nibiru Token',
		symbol: 'NIBI',
	},
	rpcUrls: {
		default: { http: ['https://evm-rpc.testnet-2.nibiru.fi'] },
	},
	blockExplorers: {
		default: {
			name: 'Nibiru Explorer',
			url: 'https://explorer.nibiru.fi/nibiru-testnet-2',
		},
	},
});

export const astarShibuyaTestnet = /*#__PURE__*/ defineChain({
	id: 81,
	name: 'Astar Shibuya Testnet',
	nativeCurrency: {
		decimals: 18,
		name: 'Shelby',
		symbol: 'SBY',
	},
	rpcUrls: {
		default: { http: ['https://evm.shibuya.astar.network'] },
	},
	blockExplorers: {
		default: {
			name: 'Subscan',
			url: 'https://shibuya.subscan.io/',
		},
	},
});

export const hashkeyTestnet = /*#__PURE__*/ defineChain({
	id: 133,
	name: 'HashKey Chain Testnet',
	nativeCurrency: {
		decimals: 18,
		name: 'Hashkey Token',
		symbol: 'HSK',
	},
	rpcUrls: {
		default: { http: ['https://testnet.hsk.xyz/'] },
	},
	blockExplorers: {
		default: {
			name: 'HashKey Chain Testnet explorer',
			url: 'https://hashkeychain-testnet-explorer.alt.technology/',
		},
	},
});

export const riseSepolia = /*#__PURE__*/ defineChain({
	id: 11155931,
	name: 'Rise Sepolia Testnet',
	nativeCurrency: {
		decimals: 18,
		name: 'Rise Token',
		symbol: 'RISE',
	},
	rpcUrls: {
		default: { http: ['https://testnet.riselabs.xyz'] },
	},
});

export const monadTestnet = /*#__PURE__*/ defineChain({
	id: 10143,
	name: 'Monad Testnet',
	nativeCurrency: {
		decimals: 18,
		name: 'Monad Token',
		symbol: 'MON',
	},
	rpcUrls: {
		default: { http: ['https://testnet-rpc.monad.xyz'] },
	},
	blockExplorers: {
		default: {
			name: 'Monad Testnet Explorer',
			url: 'https://testnet.monadexplorer.com/',
		},
	},
});

export const bsquaredTestnet = /*#__PURE__*/ defineChain({
	id: 1123,
	name: 'B2 Testnet',
	nativeCurrency: {
		decimals: 18,
		name: 'BSquared Token',
		symbol: '$B2',
	},
	rpcUrls: {
		default: { http: ['https://b2-testnet.alt.technology/'] },
	},
	blockExplorers: {
		default: {
			name: 'The B² Network Testnet Blockchain Explorer',
			url: 'hhttps://testnet-explorer.bsquared.network/',
		},
	},
});

const mintSepoliaTestnet = /*#__PURE__*/ defineChain({
	id: 1687,
	name: 'Mint Sepolia Testnet',
	nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
	rpcUrls: {
		default: {
			http: ['https://sepolia-testnet-rpc.mintchain.io/'],
		},
	},
	blockExplorers: {
		default: {
			name: 'Mintchain Testnet explorer',
			url: 'https://testnet-explorer.mintchain.io',
		},
	},
	testnet: true,
});

export const plumeTestnet = /*#__PURE__*/ defineChain({
	id: 98867,
	name: 'Plume Testnet',
	nativeCurrency: {
		name: 'Plume Sepolia Ether',
		symbol: 'PLUME',
		decimals: 18,
	},
	rpcUrls: {
		default: {
			http: ['https://testnet-rpc.plumenetwork.xyz'],
			webSocket: ['wss://testnet-rpc.plumenetwork.xyz'],
		},
	},
	blockExplorers: {
		default: {
			name: 'Blockscout',
			url: 'https://explorer-plume-testnet-1.t.conduit.xyz',
		},
	},
	testnet: true,
});

export const syscoinTestnet = /*#__PURE__*/ defineChain({
	id: 5700,
	name: 'Syscoin Tanenbaum Testnet',
	nativeCurrency: {
		decimals: 18,
		name: 'Syscoin',
		symbol: 'SYS',
	},
	rpcUrls: {
		default: {
			http: ['https://rpc1-tanenbaum.rollux.com/'],
			webSocket: ['wss://rpc.tanenbaum.io/wss'],
		},
	},
	blockExplorers: {
		default: {
			name: 'SyscoinTestnetExplorer',
			url: 'https://tanenbaum.io',
		},
	},
	contracts: {
		multicall3: {
			address: '0xcA11bde05977b3631167028862bE2a173976CA11',
			blockCreated: 271288,
		},
	},
});

export const evmosTestnet = /*#__PURE__*/ defineChain({
	id: 9_000,
	name: 'Evmos Testnet',
	nativeCurrency: {
		decimals: 18,
		name: 'Evmos',
		symbol: 'tEVMOS',
	},
	rpcUrls: {
		default: { http: ['https://evmos-testnet-evm-rpc.publicnode.com'] },
	},
	blockExplorers: {
		default: {
			name: 'Evmos Testnet Block Explorer',
			url: 'https://evm.evmos.dev/',
		},
	},
});

export const vrfChains: readonly [Chain, ...Chain[]] = [
	acala,
	ancient8,
	ancient8Sepolia,
	anvil,
	apexTestnet,
	arbitrum,
	arbitrumGoerli,
	arbitrumNova,
	astar,
	astarZkEVM,
	astarZkyoto,
	arbitrumSepolia,
	areonNetwork,
	areonNetworkTestnet,
	aurora,
	auroraTestnet,
	auroria,
	avalanche,
	avalancheFuji,
	bahamut,
	base,
	baseGoerli,
	baseSepolia,
	beam,
	beamTestnet,
	bearNetworkChainMainnet,
	bearNetworkChainTestnet,
	berachainTestnet,
	bevmMainnet,
	bitkub,
	bitkubTestnet,
	bitTorrent,
	bitTorrentTestnet,
	blast,
	blastSepolia,
	bob,
	boba,
	bobaSepolia,
	bronos,
	bronosTestnet,
	bsc,
	bscTestnet,
	bscGreenfield,
	bsquaredTestnet,
	btr,
	btrTestnet,
	bxn,
	bxnTestnet,
	canto,
	celo,
	celoAlfajores,
	chiliz,
	citreaTestnet,
	classic,
	confluxESpace,
	confluxESpaceTestnet,
	coreDao,
	cronos,
	cronosTestnet,
	crossbell,
	cyber,
	cyberTestnet,
	darwinia,
	defichainEvm,
	defichainEvmTestnet,
	degen,
	dfk,
	dodochainTestnet,
	dogechain,
	dreyerxMainnet,
	edgeless,
	edgelessTestnet,
	edgeware,
	edgewareTestnet,
	eon,
	eos,
	eosTestnet,
	etherlinkTestnet,
	evmos,
	evmosTestnet,
	ekta,
	ektaTestnet,
	fantom,
	fantomSonicTestnet,
	fantomTestnet,
	fibo,
	filecoin,
	filecoinCalibration,
	filecoinHyperspace,
	flare,
	flareTestnet,
	flowPreviewnet,
	flowMainnet,
	flowTestnet,
	foundry,
	fraxtal,
	fraxtalTestnet,
	funkiSepolia,
	fuse,
	fuseSparknet,
	iotex,
	iotexTestnet,
	jbc,
	jbcTestnet,
	karura,
	gobi,
	goerli,
	gnosis,
	gnosisChiado,
	ham,
	hardhat,
	harmonyOne,
	haqqMainnet,
	haqqTestedge2,
	hedera,
	hederaTestnet,
	hederaPreviewnet,
	holesky,
	immutableZkEvm,
	immutableZkEvmTestnet,
	inEVM,
	kakarotSepolia,
	kava,
	kavaTestnet,
	kcc,
	klaytn,
	klaytnBaobab,
	kroma,
	kromaSepolia,
	l3x,
	l3xTestnet,
	lightlinkPegasus,
	lightlinkPhoenix,
	linea,
	lineaGoerli,
	lineaSepolia,
	lineaTestnet,
	lisk,
	liskSepolia,
	localhost,
	lukso,
	luksoTestnet,
	lycan,
	mainnet,
	mandala,
	manta,
	mantaSepoliaTestnet,
	mantaTestnet,
	mantle,
	mantleSepoliaTestnet,
	mantleTestnet,
	merlin,
	metachain,
	metachainIstanbul,
	metalL2,
	meter,
	meterTestnet,
	metis,
	metisGoerli,
	mev,
	mevTestnet,
	mintSepoliaTestnet,
	mode,
	modeTestnet,
	moonbaseAlpha,
	moonbeam,
	moonbeamDev,
	moonriver,
	morphSepolia,
	nautilus,
	neonDevnet,
	neonMainnet,
	nexi,
	nexilix,
	oasys,
	oasisTestnet,
	okc,
	optimism,
	optimismGoerli,
	optimismSepolia,
	opBNB,
	opBNBTestnet,
	oortMainnetDev,
	otimDevnet,
	palm,
	palmTestnet,
	playfiAlbireo,
	pgn,
	pgnTestnet,
	phoenix,
	plinga,
	plumeMainnet,
	// plumeTestnet,
	polygon,
	polygonAmoy,
	polygonMumbai,
	polygonZkEvm,
	polygonZkEvmCardona,
	polygonZkEvmTestnet,
	pulsechain,
	pulsechainV4,
	qMainnet,
	qTestnet,
	redbellyTestnet,
	redstone,
	reyaNetwork,
	rollux,
	rolluxTestnet,
	ronin,
	rootstock,
	rootstockTestnet,
	rss3,
	rss3Sepolia,
	saigon,
	sapphire,
	sapphireTestnet,
	satoshiVM,
	satoshiVMTestnet,
	scroll,
	scrollSepolia,
	sei,
	seiDevnet,
	sepolia,
	shimmer,
	shimmerTestnet,
	skaleBlockBrawlers,
	skaleCalypso,
	skaleCalypsoTestnet,
	skaleCryptoBlades,
	skaleCryptoColosseum,
	skaleEuropa,
	skaleEuropaTestnet,
	skaleExorde,
	skaleHumanProtocol,
	skaleNebula,
	skaleNebulaTestnet,
	skaleRazor,
	skaleTitan,
	skaleTitanTestnet,
	songbird,
	songbirdTestnet,
	spicy,
	shardeumSphinx,
	shibarium,
	stratis,
	syscoin,
	syscoinTestnet,
	taraxa,
	taiko,
	taikoHekla,
	taikoJolnir,
	taikoKatla,
	taikoTestnetSepolia,
	taraxaTestnet,
	telcoinTestnet,
	telos,
	telosTestnet,
	tenet,
	thaiChain,
	thunderTestnet,
	vechain,
	wanchain,
	wanchainTestnet,
	wemix,
	wemixTestnet,
	xLayerTestnet,
	xLayer,
	xai,
	xaiTestnet,
	xdc,
	xdcTestnet,
	yooldoVerse,
	yooldoVerseTestnet,
	zetachain,
	zetachainAthensTestnet,
	zhejiang,
	zilliqa,
	zilliqaTestnet,
	zkFair,
	zkFairTestnet,
	zksync,
	zora,
	zoraSepolia,
	zoraTestnet,
	//Additional mainnet chains
	goldFever,
	//Additional testnet chains
	dfkTestnet,
	dogechainDevnet,
	bobaTestnet,
	harmonyTestnet,
	okexTestnet,
	kccTestnet,
	roninTestnet,
	goldFeverTestnet,
	apechainTestnet,
	metisSepolia,
	viction,
	coreDaoTestnet,
	plumeTestnet,
	game7Testnet,
	sonicBlazeTestnet,
	japanOpenChainTestnet,
	nibiruTestnet,
	astarShibuyaTestnet,
	hashkeyTestnet,
	riseSepolia,
	monadTestnet,
];

const connectors =
	typeof window !== 'undefined'
		? [
				metaMask({
					extensionOnly: true,
					dappMetadata: {
						name: 'Supra VRF Subscription Manager',
						url: getBaseUrl(),
						iconUrl: apiAssetsUrl + '/images/logos/supra-logo.svg',
					},
				}),
			]
		: [];

export const wagmiConfig = createConfig({
	chains: vrfChains,
	connectors,
	ssr: true,
	transports: {
		//mainnets
		[arbitrum.id]: http(arbitrum.rpcUrls.default.http[0]),
		[avalanche.id]: http(avalanche.rpcUrls.default.http[0]),
		[base.id]: http(base.rpcUrls.default.http[0]),
		[bsc.id]: http(bsc.rpcUrls.default.http[0]),
		[dfk.id]: http(dfk.rpcUrls.default.http[0]),
		[dogechain.id]: http(dogechain.rpcUrls.default.http[0]),
		[klaytn.id]: http(klaytn.rpcUrls.default.http[0]),
		[mantle.id]: http(mantle.rpcUrls.default.http[0]),
		[optimism.id]: http(optimism.rpcUrls.default.http[0]),
		[polygon.id]: http(polygon.rpcUrls.default.http[0]),
		[cronos.id]: http(cronos.rpcUrls.default.http[0]),
		[arbitrumNova.id]: http(arbitrumNova.rpcUrls.default.http[0]),
		[syscoin.id]: http(syscoin.rpcUrls.default.http[0]),
		[mainnet.id]: http(mainnet.rpcUrls.default.http[0]),
		[linea.id]: http(linea.rpcUrls.default.http[0]),
		[blast.id]: http(blast.rpcUrls.default.http[0]),
		[kroma.id]: http(kroma.rpcUrls.default.http[0]),
		[xdc.id]: http(xdc.rpcUrls.default.http[0]),
		[fuse.id]: http(fuse.rpcUrls.default.http[0]),
		[xai.id]: http(xai.rpcUrls.default.http[0]),
		[goldFever.id]: http(goldFever.rpcUrls.default.http[0]),
		[ronin.id]: http(ronin.rpcUrls.default.http[0]),
		[plumeMainnet.id]: http(plumeMainnet.rpcUrls.default.http[0]),
		//testnets
		[arbitrumSepolia.id]: http(arbitrumSepolia.rpcUrls.default.http[0]),
		[baseSepolia.id]: http(baseSepolia.rpcUrls.default.http[0]),
		[bscTestnet.id]: http(bscTestnet.rpcUrls.default.http[0]),
		[dfkTestnet.id]: http(dfkTestnet.rpcUrls.default.http[0]),
		[dogechainDevnet.id]: http(dogechainDevnet.rpcUrls.default.http[0]),
		[sepolia.id]: http(sepolia.rpcUrls.default.http[0]),
		[klaytnBaobab.id]: http(klaytnBaobab.rpcUrls.default.http[0]),
		[optimismSepolia.id]: http(optimismSepolia.rpcUrls.default.http[0]),
		[polygonMumbai.id]: http(polygonMumbai.rpcUrls.default.http[0]),
		[syscoinTestnet.id]: http(syscoinTestnet.rpcUrls.default.http[0]),
		[celoAlfajores.id]: http(celoAlfajores.rpcUrls.default.http[0]),
		[fantomTestnet.id]: http(fantomTestnet.rpcUrls.default.http[0]),
		[astarZkEVM.id]: http(astarZkEVM.rpcUrls.default.http[0]),
		[evmosTestnet.id]: http(evmosTestnet.rpcUrls.default.http[0]),
		[bobaTestnet.id]: http(bobaTestnet.rpcUrls.default.http[0]),
		[gnosisChiado.id]: http(gnosisChiado.rpcUrls.default.http[0]),
		[harmonyTestnet.id]: http(harmonyTestnet.rpcUrls.default.http[0]),
		[okexTestnet.id]: http(okexTestnet.rpcUrls.default.http[0]),
		[iotexTestnet.id]: http(iotexTestnet.rpcUrls.default.http[0]),
		[kccTestnet.id]: http(kccTestnet.rpcUrls.default.http[0]),
		[avalancheFuji.id]: http(avalancheFuji.rpcUrls.default.http[0]),
		[fuseSparknet.id]: http(fuseSparknet.rpcUrls.default.http[0]),
		[holesky.id]: http(holesky.rpcUrls.default.http[0]),
		[immutableZkEvmTestnet.id]: http(immutableZkEvmTestnet.rpcUrls.default.http[0]),
		[kromaSepolia.id]: http(kromaSepolia.rpcUrls.default.http[0]),
		[blastSepolia.id]: http(blastSepolia.rpcUrls.default.http[0]),
		[roninTestnet.id]: http(roninTestnet.rpcUrls.default.http[0]),
		[taikoKatla.id]: http(taikoKatla.rpcUrls.default.http[0]),
		[goldFeverTestnet.id]: http(goldFeverTestnet.rpcUrls.default.http[0]),
		[xaiTestnet.id]: http(xaiTestnet.rpcUrls.default.http[0]),
		[xdcTestnet.id]: http(xdcTestnet.rpcUrls.default.http[0]),
		[apechainTestnet.id]: http(apechainTestnet.rpcUrls.default.http[0]),
		[xLayerTestnet.id]: http(xLayerTestnet.rpcUrls.default.http[0]),
		[taikoHekla.id]: http(taikoHekla.rpcUrls.default.http[0]),
		[berachainTestnet.id]: http(berachainTestnet.rpcUrls.default.http[0]),
		[mintSepoliaTestnet.id]: http(mintSepoliaTestnet.rpcUrls.default.http[0]),
		[polygonAmoy.id]: http(polygonAmoy.rpcUrls.default.http[0]),
		[astarZkyoto.id]: http(astarZkyoto.rpcUrls.default.http[0]),
		[pulsechainV4.id]: http(pulsechainV4.rpcUrls.default.http[0]),
		[lineaSepolia.id]: http(lineaSepolia.rpcUrls.default.http[0]),
		[metisSepolia.id]: http(metisSepolia.rpcUrls.default.http[0]),
		[mantaSepoliaTestnet.id]: http(mantaSepoliaTestnet.rpcUrls.default.http[0]),
		[mantleSepoliaTestnet.id]: http(mantleSepoliaTestnet.rpcUrls.default.http[0]),
		[viction.id]: http(viction.rpcUrls.default.http[0]),
		[coreDaoTestnet.id]: http(coreDaoTestnet.rpcUrls.default.http[0]),
		[plumeTestnet.id]: http(plumeTestnet.rpcUrls.default.http[0]),
		[game7Testnet.id]: http(game7Testnet.rpcUrls.default.http[0]),
		[sonicBlazeTestnet.id]: http(sonicBlazeTestnet.rpcUrls.default.http[0]),
		[japanOpenChainTestnet.id]: http(japanOpenChainTestnet.rpcUrls.default.http[0]),
		[nibiruTestnet.id]: http(nibiruTestnet.rpcUrls.default.http[0]),
		[hashkeyTestnet.id]: http(hashkeyTestnet.rpcUrls.default.http[0]),
		[riseSepolia.id]: http(riseSepolia.rpcUrls.default.http[0]),
		[monadTestnet.id]: http(monadTestnet.rpcUrls.default.http[0]),
		[bsquaredTestnet.id]: http(bsquaredTestnet.rpcUrls.default.http[0]),
		[astarShibuyaTestnet.id]: http(astarShibuyaTestnet.rpcUrls.default.http[0]),
		[citreaTestnet.id]: http(citreaTestnet.rpcUrls.default.http[0]),
	},
});
